import styled from 'styled-components'
import { IfInsuranceSend } from './IfInsuranceSend'
import { businessDashboardAlertsLocalStorageKey, ifInsuranceFormSentCacheKey } from '@root/utils'
import { useBusinessContext } from '@root/context'
import { useLocalStorage } from '@root/hooks'
import { uniq } from 'lodash'
import { DashboardAlertTypes } from '@root/query'
import IfInsuranceThankYou from './IfInsuranceThankYou'

export const IfInsurancePage = () => {
  const { slug } = useBusinessContext()

  const [hasSentForm, setHasSentForm] = useLocalStorage(ifInsuranceFormSentCacheKey(slug), false)
  const [, setAlertCardDismissed] = useLocalStorage(
    businessDashboardAlertsLocalStorageKey(slug),
    []
  )

  const onFormSentSuccess = () => {
    setHasSentForm(true)

    // Close both IF cards related to the form in a single state update
    setAlertCardDismissed(prev =>
      uniq([
        ...prev,
        DashboardAlertTypes.IF_INSURANCE_NEW_BUSINESS,
        DashboardAlertTypes.IF_INSURANCE_TENDERING
      ])
    )
  }

  return (
    <StyledPage>
      {hasSentForm ? <IfInsuranceThankYou /> : <IfInsuranceSend onSuccess={onFormSentSuccess} />}
    </StyledPage>
  )
}

const StyledPage = styled.div`
  width: 100dvw;
  height: 100dvh;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.neutralGray};
  padding: ${({ theme }) => theme.spacing.xxl}rem;

  @media (max-width: 768px) {
    padding: 0;
  }
`
